import { styled, CSSObject, forBrands } from '@core-ui/react-stitch';
import { GenerateItemStyles, GridRootProps } from './types';

const getBrStyle = (): CSSObject =>
  ({
    padding: 0,
    minHeight: '0.5em',
  } as CSSObject);

// eslint-disable-next-line complexity
const generateItemStyles = ({
  columnSize,
  numberOfColumns,
  spacing,
  theme,
}: GenerateItemStyles): CSSObject => {
  const percentage = columnSize ? (columnSize * 100) / numberOfColumns : 100;
  const width = `${percentage}%`;

  return {
    boxSizing: 'border-box',
    flexBasis: width,
    flexGrow: 0,
    margin: 0,
    maxWidth: width,
    ...(forBrands(theme, {
      br: getBrStyle,
      brfs: getBrStyle,
      default: () => ({ padding: `${spacing}em` }),
    }) as CSSObject),
  };
};

const GridRoot = styled.div<GridRootProps>(
  ({ numberOfColumns, spacing, columnSize, theme }: GridRootProps) => ({
    ...generateItemStyles({
      columnSize,
      numberOfColumns,
      spacing: spacing || 0.5,
      theme,
    }),
  })
);

export default GridRoot;
